export default [
  {
    path: "/request-SAML-site",
    name: "requestSAMLSite",
    component: () => import("@/pages/CommonPages/RequestSAMLSitePage"),
  },
];
